
import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { connect } from 'react-redux';

import LoginLayout from './layouts/LoginLayout';
import CoreLayout from './layouts/CoreLayout';
import Login from './views/LoginView';
import Invoices from './components/Invoices/Invoices';
import { ChangePayment } from './components/Payment';
import { EditInfo, PersonalInfo, EditAddress } from './components/InfoPerson';
import { MobileLine, FixedLine, Internet, TV, Bundles } from './components/MyServices';
import { FreezeForm, FreezeList } from './components/Freeze/index';
import { CallDetails } from './components/CallDetails';
import { ManageVoicemail } from './components/ManageVoicemail';
import PageNotAvailable from './components/PageNotAvailable/PageNotAvailable';
import ChangePassword from './components/ChangePassword/ChangePassword';
import { ManageMispari } from './components/Mispari';
import FaxTable from './components/Fax/FaxSended';

import {  getActiveLanguage } from 'react-localize-redux';
import LineParameters from './components/Line/Parameters';

let Routes = (props) => (
  <BrowserRouter >
    <div>
      <Switch >
        <CoreLayout  exact path="/" component={MobileLine} />
        <CoreLayout  exact path={`/${props.currentLanguage}`} component={MobileLine} />
        <CoreLayout  exact path={`/${props.currentLanguage}`} component={PersonalInfo} />
        <LoginLayout  exet path={`/${props.currentLanguage}/auth/login/:id/:token`} component={Login} />
        <LoginLayout  exet path={`/auth/login/:id/:token`} component={Login} />
        <LoginLayout  exet path={`/${props.currentLanguage}/auth/login`} component={Login} />
        <CoreLayout exet path={`/${props.currentLanguage}/personalinfo/changepasswod`} component={ChangePassword} />
        <CoreLayout exet path={`/${props.currentLanguage}/personalinfo`} component={PersonalInfo} />
        <CoreLayout exet path={`/${props.currentLanguage}/edit/info`} component={EditInfo} />
        <CoreLayout exet path={`/${props.currentLanguage}/edit/address`} component={EditAddress} />
        <CoreLayout exet path={`/${props.currentLanguage}/edit/payment`} component={ChangePayment} />
        <CoreLayout exet path={`/${props.currentLanguage}/bills/:page`} component={Invoices} />
        <CoreLayout exet path={`/${props.currentLanguage}/bills/`} component={Invoices} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/lines-mobile`} component={MobileLine} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/lines-fixe`} component={FixedLine} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/internet`} component={Internet} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/tv`} component={TV} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/freeze/:userProductId`} component={FreezeForm} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/freeze`} component={FreezeForm} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/listfreezes/:userProductId`} component={FreezeList} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/consumption/:userProductId/:page`} component={CallDetails} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/consumption/:userProductId/`} component={CallDetails} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/voiceMail/:userProductId/`} component={ManageVoicemail} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/mispari/:userProductId/`} component={ManageMispari} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/mispari/:userProductId/`} component={ManageMispari} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/faxSended/:userProductId/`} component={FaxTable} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line/parameters/:userProductId/`} component={LineParameters} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/line`} component={MobileLine} />
        <CoreLayout exet path={`/${props.currentLanguage}/services/bundles`} component={Bundles} />
        <CoreLayout path="/" component={PageNotAvailable} />
      </Switch>
    </div>
  </BrowserRouter>
);
const viewMapStateToProps = (state) => {
  return {
    currentLanguage: getActiveLanguage(state.locale).code,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {
  };
};
Routes = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(Routes);
export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js